<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <p class="sub_title">
        服务介绍
      </p>
      <div class="content_A">
        <div>
          代码审计就是从安全的角度对整个代码质量进行审计，在黑客之前发现系统代码漏洞，
          找出应用系统的安全隐患， 并给出相应的安全报告和修复方法，
          从而提高客户应用系统的安全性。 代码审计的对象包括并不限以下：
        </div>
        <div
          v-for="fwjs in introduceList"
          :key="fwjs.id"
          class="content_list"
        >
          <div>{{ fwjs.content }}</div>
        </div>
      </div>
    </div>
    <div class="procedures">
      <p class="sub_title">
        服务流程
      </p>
      <div class="lists">
        <div
          v-for="item in processList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <div class="content">
              <div>{{ item.title }}</div>
              <div>
                <img
                  src="@/assets/securityServices/audit1.png"
                  alt=""
                >
              </div>
              <div>{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cost">
      <p class="sub_title">
        服务价值
      </p>
      <div class="lists">
        <div
          v-for="item in costList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <img
              class="cost_img"
              :src="item.imgUrl"
              alt=""
            >
            <div class="content">
              <p>{{ item.title }}</p>
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Audit',
  components: {
    banner
  },
  data() {
    return {
      title: '代码审计服务',
      content:
        '代码审计是对编程项目中的源代码进行全面分析， 旨在发现错误， 安全漏洞或其他违反编程约定的分析方法。',
      introduceList: [
        {
          id: 1,
          content: '1、即将上线的新系统平台。'
        },
        {
          id: 2,
          content: '2、存在大晕用户访问、 高可用、 高并发请求的网站。'
        },
        {
          id: 3,
          content: '3、存在用户资料等敏感机密信息的企业平台。'
        },
        {
          id: 4,
          content: '4、互联网金融类存在业务逻辑问题的企业平台。'
        },
        {
          id: 5,
          content: '5、开发过程中对重要业务功能需要进行局部安全测试的平台。'
        }
      ],
      processList: [
        {
          id: 1,
          title: '前期准备阶段',
          content: '和客户就代码审计服务相关技术细节进行详细沟通。'
        },
        {
          id: 2,
          title: '代码审计分析阶段',
          content:
            '使用代码审计工具对源代码进行自动化检测， 完成初步的信息收集， 然后由人工的方式对源代码检测结果进行分析和确认。'
        },
        {
          id: 3,
          title: '复查验证阶段',
          content:
            '根据代码审计报告进行整改加固，经整改加固后，进行二次检查，结束后提交给复查报告。'
        },
        {
          id: 4,
          title: '成果汇报阶段',
          content: '为客户提供源代码安全问题解决方案，完善代码安全开发规范。'
        }
      ],
      costList: [
        {
          id: 1,
          title: '明确安全隐患',
          imgUrl: require('@/assets/securityServices/inspect1.png'),
          content:
            '从整套源代码切入最终明至某个威胁点并加以验证，以此明确整体系统中的安全隐患点。'
        },
        {
          id: 2,
          title: '降低整体风险',
          imgUrl: require('@/assets/securityServices/inspect2.png'),
          content:
            '审计服务可有效督促管理人员杜绝任何一处小的缺陷，从而降低整体风险。'
        },
        {
          id: 3,
          title: '完善开发规范',
          imgUrl: require('@/assets/securityServices/inspect3.png'),
          content:
            '通过专业的代码审计服务，能为用户开发人员提供安全问题的解决方案，完善代码安全开发规范。'
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.procedures {
  width: 100%;
  margin-top: 40px;
  background: #fafbff;
  padding-top: 120px;
  padding-bottom: 135px;
  position: relative;

  .lists {
    width: 70%;
    margin: 95px auto 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .list {
      width: 22%;
      margin: 0 1%;
      border-top: 10px solid #5782e3;

      .item_list {
        width: 100%;
        box-shadow: 1px 1px 10px #dadada;
        min-height: 600px;
        background: #e8effd;

        .content {
          div:nth-child(1) {
            font-size: 24px;
            font-weight: bold;
            color: #333333;
            line-height: 40px;
            text-align: center;
            padding-top: 88px;
          }
          div:nth-child(2) {
            margin-top: 25px;
            text-align: center;
            img {
              width: 71px;
              height: 24px;
            }
          }
          div:nth-child(3) {
            width: 80%;
            margin: 78px auto 49px;
            font-size: 22px;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
          }
        }
      }
    }
  }
}
@media (min-width: 1200px)and (max-width: 1350px){
  .content_A div{
    font-size: 20px;
  }
}
</style>
